module.exports = __webpack_public_path__ + "media/images/icons/exclamationmark-circle-f4a7586580d111a80284c7f3da2c0e0b.svg";